export const WebChatCropOption = {
    showZoomer: true,
    enableExif: true,
    enableOrientation: true,
    viewport: { width: 200, height: 200, type: 'square' },
    boundary: { width: 300, height: 300 }
}

export const WebChatDontCropOption = {
    showZoomer: false,
    enableExif: true,
    enableOrientation: true,
    viewport: { width: '100%', height: '100%'}
}
